// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__AdjustmentsPage__premium-text{margin-top:-40px!important}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-quoteandbind-common-react/pages/Adjustments/AdjustmentsPage.module.scss"],"names":[],"mappings":"AAAA,oCACI,0BAAA","sourcesContent":[".premium-text{\n    margin-top: -40px !important ;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"premium-text": "app__AdjustmentsPage__premium-text"
};
export default ___CSS_LOADER_EXPORT___;
